










































import FilterParams from '@/types/FilterParams.interface'
import Vue from 'vue'
import { randomKey } from '@/utility/helpers'
export default Vue.extend({
    props: {
        //  Applies the compact style
        compact: {
            type: Boolean,
            default: false
        },
        //  Applies the compact with no padding style
        compactPad: {
            type: Boolean,
            default: false
        },
        //  Determines if this filter is disabled or not
        disabled: {
            type: Boolean,
            default: false
        },
        //  The filter the component is bound to
        filter: {
            type: Object,
            required: true
        },
        //  The name of our filter for Cypress
        filterName: {
            type: String,
            default: null
        },
        //  The type of module we are filtering so we can find the appropraite getter
        filterType: {
            type: String,
            default: ''
        },
        //  Determines if the dropdown arrow appears or not
        hideIcon: {
            type: Boolean,
            default: false
        },
        //  Applies a min-width to the component
        minWidth: {
            type: String,
            default: null
        },
        //  Determines if we use multi select or single select
        multiple: {
            type: Boolean,
            default: false
        },
        //  The tooltip we want displayed on our select
        tooltip: {
            type: String,
            default: null
        },
        //  Applies a max-width to the component
        width: {
            type: String,
            default: null
        }
    },
    mounted() {
        //  Only do this if we are using tooltips AND not in the mobile app
        if (!this.tooltip || this.isApp) return

        //  Grab our container
        const dom = document.getElementById(this.id)

        //  Grab our tooltip
        const tool = document.getElementById(this.tooltipId)

        //  Add enter event listener
        dom.addEventListener('mouseenter', function (e) {
            //  Set display to inline block
            tool.style.display = 'inline-block'
        })

        //  Add leave event listener
        dom.addEventListener('mouseleave', function (e) {
            //  Set display to inline block
            tool.style.display = 'none'
        })
    },
    computed: {
        id(): string {
            //  Generate a random id
            return randomKey()
        },
        isApp(): boolean {
            return this.$store.getters.isApp
        },
        //  Filter out 'hidden' options
        options(): FilterParams {
            return this.filter.options.filter((x: FilterParams) => x.hidden !== true)
        },
        //  Apply a styling theme to the component
        theme(): string {
            if (this.compact) return 'compact'
            if (this.compactPad) return 'compact-pad'
        },
        tooltipId(): string {
            //  Generate a random id
            return randomKey()
        },
        tooltipStyle(): object {
            return {
                position: 'absolute',
                top: '0px',
                'background-color': 'rgb(117,117,117)',
                color: '#ffffff',
                'border-color': 'rgb(117,117,117)',
                'z-index': 99,
                'border-radius': '4px',
                background: 'rgba(97,97,97,0.9)',
                width: 'auto',
                padding: '5px 16px',
                'pointer-events': 'none',
                opacity: 0.9,
                'font-size': '14px',
                display: 'none'
            }
        }
    },
    methods: {
        submit(): void {
            //  Check if an '@filteredChanged' event listener is set on the component
            const hasEvent = this.$listeners.filterChanged

            //  If the component's parent is listening for changes, emit the selected filter to the parent
            if (hasEvent) this.$emit('filterChanged', this.filter.selected)
        }
    }
})
